(function(){
function detectLocale(){
  var lang=(document.documentElement.getAttribute("lang")||"").toLowerCase();
  if(lang.startsWith("ca"))return"ca";
  if(lang.startsWith("en"))return"en";
  if(lang.startsWith("fr"))return"fr";
  if(lang.startsWith("it"))return"it";
  var path=window.location.pathname;
  return path.startsWith("/ca/")?"ca":path.startsWith("/en/")?"en":path.startsWith("/fr/")?"fr":path.startsWith("/it/")?"it":path.startsWith("/pt/")?"pt":"es";
}
var L=detectLocale();
var STR={
  es:{with:"Con",of:"de",g_single:"gramo",g_plural:"gramos",f250:["botella","botellas"],f330:["lata","latas"],f750:["botella","botellas"],f250_lbl:"Botella 250 ml",f330_lbl:"Lata 330 ml",f750_lbl:"Botella 750 ml"},
  ca:{with:"Amb",of:"de",g_single:"gram",g_plural:"grams",f250:["ampolla","ampolles"],f330:["llauna","llaunes"],f750:["ampolla","ampolles"],f250_lbl:"Ampolla 250 ml",f330_lbl:"Llauna 330 ml",f750_lbl:"Ampolla 750 ml"},
  en:{with:"With",of:"of",g_single:"gram",g_plural:"grams",f250:["bottle","bottles"],f330:["can","cans"],f750:["bottle","bottles"],f250_lbl:"Bottle 250 ml",f330_lbl:"Can 330 ml",f750_lbl:"Bottle 750 ml"},
  fr:{with:"Avec",of:"de",g_single:"gramme",g_plural:"grammes",f250:["bouteille","bouteilles"],f330:["canette","canettes"],f750:["bouteille","bouteilles"],f250_lbl:"Bouteille 250 ml",f330_lbl:"Canette 330 ml",f750_lbl:"Bouteille 750 ml"},
  it:{with:"Con",of:"di",g_single:"grammo",g_plural:"grammi",f250:["bottiglia","bottiglie"],f330:["lattina","lattine"],f750:["bottiglia","bottiglie"],f250_lbl:"Bottiglia 250 ml",f330_lbl:"Lattina 330 ml",f750_lbl:"Bottiglia 750 ml"},
  pt:{with:"Com",of:"de",g_single:"grama",g_plural:"gramas",f250:["garrafa","garrafas"],f330:["lata","latas"],f750:["garrafa","garrafas"],f250_lbl:"Garrafa 250 ml",f330_lbl:"Lata 330 ml",f750_lbl:"Garrafa 750 ml"}
};
var T=STR[L]||STR.es;

// Varietats disponibles en 750ml
var HAS_750 = ["hibiscus","ginger","natural"];

var VARIETIES=[
  {id:"hibiscus",name:"HIBISCUS",family:"Premium",sugar:0.09},
  {id:"not-birra-l",name:"Not-Birra Lemon",family:"NoLo",sugar:0.16},
  {id:"not-birra",name:"Not-Birra",family:"NoLo",sugar:0.20},
  {id:"green",name:"GREEN",family:"Premium",sugar:0.50},
  {id:"verbena",name:"VERBENA",family:"Premium",sugar:0.50},
  {id:"flowers",name:"FLOWERS",family:"Premium",sugar:0.50},
  {id:"menta-melocoton",name:"Menta-Melocotón",family:"Casual",sugar:0.50},
  {id:"ginger",name:"GINGER",family:"Premium",sugar:0.60},
  {id:"jengibre-lim",name:"Jengibre Limón",family:"Casual",sugar:0.60},
  {id:"isotonic",name:"Isotonic",family:"Functional",sugar:0.61},
  {id:"not-mojito",name:"Not-Mojito",family:"NoLo",sugar:0.70},
  {id:"frutos-rojos",name:"Frutos Rojos",family:"Casual",sugar:0.90},
  {id:"curcuma",name:"Cúrcuma Naranja",family:"Casual",sugar:1.30},
  {id:"natural",name:"NATURAL",family:"Premium",sugar:1.80},
  {id:"original",name:"Original",family:"Casual",sugar:1.80}
];
window.MUN_VARIETIES=VARIETIES;
var selVar=VARIETIES[0], selFmt=250, qty=1, OMS_LIMIT=25;

function plural(arr,n){return arr[n===1?0:1];}
function fmtNum(n){return n.toFixed(2).replace(".",",");}

function makeChip(v,active){
  var btn=document.createElement("button");
  btn.type="button";
  btn.className="widget-pill"+(active?" active":"");
  btn.setAttribute("data-variety",v.id);
  btn.setAttribute("data-sugar",v.sugar);
  btn.textContent=v.name;
  btn.addEventListener("click",function(){
    var c=btn.parentElement;
    if(c) c.querySelectorAll("button").forEach(function(b){b.classList.remove("active");});
    btn.classList.add("active");
    selVar=v;
    update750Availability();
    updateResult();
  });
  return btn;
}

function ensureChips(){
  var c=document.getElementById("variety-pills");
  if(!c) return false;
  // Always rebuild to ensure correct order + complete
  c.innerHTML='';
  VARIETIES.forEach(function(v,idx){
    c.appendChild(makeChip(v, idx===0));
  });
  return true;
}

function makeTableRow(v){
  var sugarClass=v.sugar<0.5?"v-sugar--low":v.sugar<1.5?"v-sugar--med":"v-sugar--high";
  var l250=fmtNum(v.sugar*2.5)+" g";
  var l330=fmtNum(v.sugar*3.3)+" g";
  var b750=fmtNum(v.sugar*7.5)+" g";
  // 250ml only for non-Casual
  if(v.family==="Casual" || v.family==="NoLo") l250="—";
  // 750ml only for HAS_750 varieties
  if(HAS_750.indexOf(v.id)===-1) b750="—";
  var tr=document.createElement("tr");
  tr.setAttribute("data-name",v.name);
  tr.setAttribute("data-sugar",v.sugar);
  tr.innerHTML='<td class="v-var">'+v.name+'</td>'+
    '<td class="v-sugar-cell"><span class="v-sugar '+sugarClass+'">'+fmtNum(v.sugar)+' g</span></td>'+
    '<td>'+l250+'</td><td>'+l330+'</td><td>'+b750+'</td><td>'+v.family+'</td>';
  return tr;
}

function ensureTable(){
  var tbody=document.getElementById("vtable-body");
  if(!tbody) return false;
  tbody.innerHTML='';
  VARIETIES.forEach(function(v){
    tbody.appendChild(makeTableRow(v));
  });
  return true;
}

function update750Availability(){
  // Hide/show 750ml button based on selected variety
  var btn750=document.querySelector('[data-format="750"]');
  if(!btn750) return;
  var available = HAS_750.indexOf(selVar.id) !== -1;
  btn750.style.display = available ? '' : 'none';
  // If 750 was selected but not available, fallback to 250
  if(!available && selFmt===750){
    selFmt=250;
    var btn250=document.querySelector('[data-format="250"]');
    document.querySelectorAll('#format-pills button').forEach(function(b){b.classList.remove('active');});
    if(btn250) btn250.classList.add('active');
  }
}

function updateResult(){
  var sugar=selVar.sugar*selFmt/100*qty;
  var n=document.getElementById("result-num");
  var s=document.getElementById("result-sub");
  var u=document.querySelector(".widget-result__unit") || document.querySelector('[class*="result"][class*="unit"]');
  if(n){
    n.textContent=fmtNum(sugar);
    n.style.fontSize="clamp(72px, 12vw, 120px)";
    n.style.fontWeight="800";
    n.style.lineHeight="1";
  }
  if(u){
    u.textContent=" "+plural([T.g_single,T.g_plural],sugar);
    u.style.marginLeft="8px";
  }
  if(s){
    var fmtArr = selFmt===250?T.f250:selFmt===330?T.f330:T.f750;
    var fmtName = plural(fmtArr,qty)+" "+selFmt+" ml";
    s.textContent = T.with+" "+qty+" "+fmtName+" "+T.of+" "+selVar.name;
  }
  var pctEl=document.getElementById("result-compare");
  if(pctEl){
    var pct=sugar/OMS_LIMIT*100;
    pctEl.querySelectorAll("strong").forEach(function(st){
      var txt=(st.textContent||"").trim();
      if(txt.indexOf("%")>-1) st.textContent=fmtNum(pct).replace(",00","")+"%";
    });
  }
}

function fixFormatPillLabels(){
  // Replace static "Lata 250 ml" wrong label with correct one per locale
  var btn250=document.querySelector('[data-format="250"]');
  var btn330=document.querySelector('[data-format="330"]');
  var btn750=document.querySelector('[data-format="750"]');
  if(btn250) btn250.textContent=T.f250_lbl;
  if(btn330) btn330.textContent=T.f330_lbl;
  if(btn750) btn750.textContent=T.f750_lbl;
}

function wireFormat(){
  var c=document.getElementById("format-pills");
  if(!c) return false;
  c.querySelectorAll("button").forEach(function(b){
    if(b.dataset.wired) return;
    b.dataset.wired="1";
    b.addEventListener("click",function(){
      c.querySelectorAll("button").forEach(function(x){x.classList.remove("active");});
      b.classList.add("active");
      selFmt=parseInt(b.getAttribute("data-format"),10)||250;
      updateResult();
    });
  });
  return true;
}

function wireSlider(){
  var s=document.getElementById("qty-slider");
  var out=document.getElementById("qty-out");
  if(!s) return false;
  s.addEventListener("input",function(){
    qty=parseInt(s.value,10)||1;
    if(out) out.textContent=qty;
    updateResult();
  });
  return true;
}

function fixEmCorruption(){
  // Find any class names corrupted by <em> tags (BEM __ → <em>)
  document.querySelectorAll("*").forEach(function(el){
    if(el.className && typeof el.className === "string" && el.className.indexOf("<em>") > -1){
      el.className = el.className.replace(/<em>/g,'__').replace(/<\/em>/g,'__');
    }
  });
  // Also remove any literal <em> tags around class names in attributes
  document.querySelectorAll('[class*="<em>"]').forEach(function(el){
    var c = el.getAttribute('class');
    if(c) el.setAttribute('class', c.replace(/<em>/g,'__').replace(/<\/em>/g,'__'));
  });
}

function fixLabels(){
  document.querySelectorAll("a, button, span").forEach(function(el){
    var t=(el.textContent||"").trim();
    if(t==="Ver las 9 variedades") el.textContent="Ver las 15 variedades";
    if(t==="Veure les 14 varietats") el.textContent="Veure les 15 varietats";
    if(t==="See the 9 varieties"||t==="See 9 varieties") el.textContent="See the 15 varieties";
    if(t==="Voir les 9 variétés") el.textContent="Voir les 15 variétés";
    if(t==="Vedi le 9 varietà") el.textContent="Vedi le 15 varietà";
  });
}

function init(){
  fixEmCorruption();
  ensureChips();
  ensureTable();
  fixFormatPillLabels();
  wireFormat();
  wireSlider();
  fixLabels();
  update750Availability();
  updateResult();
}

if(document.readyState==="complete" || document.readyState==="interactive"){init();}
else{document.addEventListener("DOMContentLoaded",init);}

var attempts=0;
var poll=setInterval(function(){
  attempts++;
  init();
  if(attempts>20) clearInterval(poll);
},500);
})();
